module.exports = __webpack_public_path__ + "img/senior-woman-reading-book-at-home-4KJ9EQB-min.a228c5b2.jpg";